/* FERÐAST.fo — optional package seats, paired with seat_service.py package endpoint.
 * Installing this asset alone does not change any existing booking flow.
 */
(() => {
  'use strict';
  if (window.TurPackageSeats) return;
  const DEPOSIT = '54717007724817';
  const SEAT = '67648320405777';
  const LEGS = [
    {flight: '2027-03-04_FAE-AEY', label: 'Útferð · 4. mars · Føroyar → Akureyri'},
    {flight: '2027-03-07_AEY-FAE', label: 'Heimferð · 7. mars · Akureyri → Føroyar'}
  ];
  const money = n => new Intl.NumberFormat('fo-FO', {style: 'currency', currency: 'DKK'}).format(n / 100);
  const root = () => window.Shopify?.routes?.root || '/';
  const LOCK = 'tur-package-seat-pending-v1';
  let open = false;
  const node = (tag, text, cls) => {
    const e = document.createElement(tag);
    if (text != null) e.textContent = text;
    if (cls) e.className = cls;
    return e;
  };
  const button = (text, handler, cls) => {
    const e = node('button', text, cls);e.type = 'button';e.addEventListener('click', handler);return e;
  };
  async function json(url, options = {}) {
    const response = await fetch(url, {cache: 'no-store', credentials: 'same-origin', ...options});
    let data;
    try { data = await response.json(); } catch { throw Error('Svarið kundi ikki lesast. Royn aftur.'); }
    if (!response.ok) {
      const message = response.status === 409 ? 'Eitt valt setur er ikki tøkt longur, ella bíleggingin skal kannast. Dagfør setrini og royn aftur.' : response.status === 400 ? 'Kanna nøvn, setur og tal av ferðafólkum. Royn síðani aftur.' : 'Upplýsingarnar kundu ikki heintast. Royn aftur ella set teg í samband við FERÐAST.fo.';
      const e = Error(message);
      e.httpStatus = response.status;throw e;
    }
    return data;
  }
  function api(config) {
    const url = new URL(config.api || '/apps/tur-seats', location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith('/apps/') || url.search || url.hash) throw Error('Skipanin til val av setri er ikki rætt sett upp.');
    return url.pathname.replace(/\/$/, '');
  }
  function pending() {
    // Fail closed if storage is unavailable: a reload must not create duplicate holds.
    try { return sessionStorage.getItem(LOCK); }
    catch { throw Error('Tað ber ikki til at goyma upplýsingar í hesum kaga. Kanna stillingarnar í kaganum, áðrenn tú velur setur.'); }
  }
  function setPending(id) {
    try { sessionStorage.setItem(LOCK, id);if (sessionStorage.getItem(LOCK) !== id) throw Error(); }
    catch { throw Error('Bíleggingin kundi ikki fyrireikast í kaganum.'); }
  }
  function uncertain(error, id) {
    const e = Error('Bíleggingin skal kannast. Opna kurvina. Er hon tóm, set teg í samband við FERÐAST.fo við tilvísing ' + id + '. ' + (error.message || ''));
    e.uncertain = true;e.packageId = id;return e;
  }
  function validate(selection) {
    const n = selection.n;
    if (!Number.isInteger(n) || n < 1 || n > 174 || !Number.isSafeInteger(selection.baseTotal) || selection.baseTotal < n * 50000) throw Error('Prísur ella ferðafólkatal skal kannast.');
    if (!Array.isArray(selection.legs) || selection.legs.length > 2) throw Error('Valið av setri er ikki gilt.');
    const seen = new Set();let names;
    for (const leg of selection.legs) {
      if (!LEGS.some(x => x.flight === leg.flight) || seen.has(leg.flight) || !Array.isArray(leg.passengers) || leg.passengers.length !== n) throw Error('Kanna ferðina og talið av ferðafólkum.');
      seen.add(leg.flight);const seats = new Set();
      for (const p of leg.passengers) {
        if (!/^(?:[1-9]|1\d|2\d)[A-F]$/.test(p.seat) || seats.has(p.seat) || typeof p.name !== 'string' || !p.name.trim() || p.name.trim().length > 100) throw Error('Skriva nøvn og vel ymisk setur til øll ferðafólk.');
        seats.add(p.seat);
      }
      const current = JSON.stringify(leg.passengers.map(p => p.name.trim()));
      if (names !== undefined && names !== current) throw Error('Nøvnini skulu vera tey somu á báðum ferðum.');
      names = current;
    }
    if (selection.legs.length && (!Number.isSafeInteger(selection.unitPrice) || selection.unitPrice <= 0 || String(selection.variantId) !== SEAT)) throw Error('Prísurin fyri setur skal kannast.');
    return selection.legs.length * n * (selection.unitPrice || 0);
  }
  async function product(config) {
    if (!config.handle) throw Error('Val av setri er ikki klárt enn.');
    const [p, cart] = await Promise.all([
      json(root() + 'products/' + encodeURIComponent(config.handle) + '.js'), json(root() + 'cart.js')
    ]);
    if (cart.currency !== 'DKK') throw Error('Vel DKK sum gjaldoyra fyri at velja setur.');
    const v = p.variants.find(x => String(x.id) === SEAT);
    if (!v?.available || v.requires_shipping || !Number.isSafeInteger(v.price) || v.price <= 0) throw Error('Val av setri er ikki tøkt í løtuni.');
    return v;
  }
  function style() {
    if (document.getElementById('tur-package-seat-style')) return;
    const s = node('style');s.id = 'tur-package-seat-style';
    s.textContent = `
body dialog.tps{box-sizing:border-box;width:min(960px,calc(100% - 24px));max-height:90vh;max-height:90dvh;border:1px solid #c5d5df;border-radius:18px;padding:26px;background:#f3f7fa;color:#123342;font:16px/1.5 system-ui,sans-serif;overflow:auto}
body dialog.tps::backdrop{background:#071c2bc9}body .tps *{box-sizing:border-box}body .tps [hidden]{display:none!important}
body .tps h2{font:400 32px/1.15 Georgia,serif;color:#123342;margin:0 0 12px}body .tps h3{font-size:18px;margin:12px 0}body .tps p{margin:10px 0}
body .tps button{position:static;min-height:44px;font:600 15px/1.2 system-ui,sans-serif;padding:10px 15px;border:1px solid #9fbacb!important;border-radius:8px;cursor:pointer;background:#dce8f0!important;color:#123342!important;box-shadow:none!important;width:auto;margin:0}
body .tps button::after,body .tps button::before{display:none!important}body .tps button:disabled{opacity:.55;cursor:default}body .tps button:focus-visible,body .tps input:focus-visible{outline:3px solid #166b8f;outline-offset:3px}
body .tps .tps-confirm{background:#b9edb2!important;border-color:#b9edb2!important;color:#12351b!important}body .tps .tps-actions{display:flex;gap:12px;flex-wrap:wrap;margin-top:20px}
body .tps .tps-legs{display:grid;grid-template-columns:1fr 1fr;gap:12px}body .tps .tps-option{display:flex;align-items:flex-start;gap:10px;padding:16px;background:white;border:1px solid #c5d5df;border-radius:12px;cursor:pointer}
body .tps input[type=checkbox]{width:20px;height:20px;flex-shrink:0;margin:3px 0;accent-color:#166b8f}body .tps .tps-names{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;margin:16px 0}
body .tps .tps-name{display:grid;gap:4px;font-size:14px}body .tps input[type=text]{width:100%;min-width:0;border:1px solid #9fbacb;border-radius:6px;background:white!important;color:#123342!important;padding:10px;font:16px system-ui,sans-serif}
body .tps .tps-tabs,body .tps .tps-pax{display:flex;flex-wrap:wrap;gap:8px;margin:12px 0}body .tps button[aria-pressed=true]{background:#166b8f!important;color:white!important;border-color:#166b8f!important}
body .tps .tps-cabin{display:grid;gap:5px;width:min(100%,430px);margin:16px auto;max-height:380px;overflow:auto;padding:5px 8px;background:white;border-radius:12px}
body .tps .tps-row{display:grid;grid-template-columns:repeat(3,minmax(0,1fr)) 25px repeat(3,minmax(0,1fr));gap:5px;align-items:center;text-align:center}
body .tps .tps-row button{padding:8px 0;min-width:0;min-height:40px;font-size:13px;background:#e3eef5!important}body .tps .tps-row button[aria-pressed=true]{background:#166b8f!important;color:white!important}body .tps .tps-row button:disabled{background:#dde1e3!important;color:#77848b!important;opacity:1}
body .tps .tps-total{background:white;border:1px solid #c5d5df;border-radius:12px;padding:16px;margin-top:18px}body .tps .tps-total strong{display:block;font-size:20px}
body .tps .tps-status{padding:10px 0;color:#123342}body .tps .tps-status:empty{display:none}body .tps .tps-small{font-size:13px;color:#536b76}
@media(max-width:600px){body dialog.tps{padding:18px}body .tps .tps-legs,body .tps .tps-names{grid-template-columns:1fr}body .tps .tps-row{gap:3px;grid-template-columns:repeat(3,minmax(0,1fr)) 18px repeat(3,minmax(0,1fr))}body .tps .tps-row button{min-height:38px}}
`;
    document.head.append(s);
  }
  async function choose(config, {n, total, title = 'Vel setur til ferðina', paymentMode = 'deposit', initialSelection = null}) {
    const full = paymentMode === 'full';
    const base = {n, baseTotal: total, unitPrice: 0, variantId: SEAT, legs: []};validate(base);
    if (!config?.enabled) return base;
    if (pending()) throw uncertain(Error('Ein fyrri bílegging er ikki avgreidd í hesum kaga.'), pending());
    if (open) throw Error('Val av setri er longu opið.');
    api(config);style();open = true;
    const focus = document.activeElement, dialog = node('dialog', null, 'tps');
    const heading = node('h2', title);heading.id = 'tps-title';dialog.setAttribute('aria-labelledby', heading.id);
    const intro = node('p', 'Tú kanst velja setur á ferðini til Akureyrar, á heimferðini ella á báðum ferðum. Vel eitt setur til hvønn ferðandi á teimum ferðum, tú velur. ' + (full ? 'Val av setri er ókeypis, tá ið tú rindar alla ferðina nú.' : 'Gjaldið fyri setrini verður goldið saman við deposituminum.'));
    const choices = node('div', null, 'tps-legs'), details = node('div'), namesBox = node('div', null, 'tps-names');
    const tabs = node('div', null, 'tps-tabs'), paxBox = node('div', null, 'tps-pax'), cabin = node('div', null, 'tps-cabin');
    const status = node('p', '', 'tps-status');status.setAttribute('role', 'status');status.setAttribute('aria-live', 'polite');
    const summary = node('div', null, 'tps-total'), actions = node('div', null, 'tps-actions');
    let unitPrice = 0, loaded = false, alive = true, refreshing = false, activeLeg = 0, passenger = 0;
    const enabled = [false, false], names = Array(n).fill(''), seats = [Array(n).fill(''), Array(n).fill('')], states = [null, null], checks = [];
    const returnEdited = Array(n).fill(false);
    if (initialSelection?.n === n) {
      for (const [i, leg] of LEGS.entries()) {
        const prior = initialSelection.legs?.find(l => l.flight === leg.flight);
        if (prior?.passengers?.length === n) {
          enabled[i] = true;
          prior.passengers.forEach((p, j) => { names[j] = p.name; seats[i][j] = p.seat; if (i === 1) returnEdited[j] = true; });
        }
      }
    }
    let returnOptOut = !!initialSelection && enabled[0] && !enabled[1];
    const returnHint = node('p', '', 'tps-small');
    returnHint.setAttribute('role', 'status');
    function suggestReturnSeats() {
      if (!enabled[0] || !enabled[1] || !states[1]) { returnHint.textContent = ''; return; }
      seats[1] = seats[1].map((seat, i) => returnEdited[i] ? seat : '');
      let missing = 0;
      seats[0].forEach((seat, i) => {
        if (returnEdited[i] || !seat) return;
        if (!states[1][seat] && !seats[1].includes(seat)) seats[1][i] = seat;
        else missing++;
      });
      returnHint.textContent = missing
        ? 'Ikki øll setrini frá útferðini eru tøk á heimferðini. Vel onnur setur til tey ferðafólk, sum mangla setur á heimferðini.'
        : 'Somu setur verða vald á heimferðini, um tey eru tøk. Tú kanst altíð velja onnur setur á heimferðini.';
    }
    let resolveResult;
    const result = new Promise(resolve => { resolveResult = resolve; });
    function finish(value) { if (!alive) return;alive = false;clearInterval(timer);dialog.close();dialog.remove();open = false;focus?.focus();resolveResult(value); }
    const confirm = button('Halt fram uttan at velja setur', () => {
      const value = selection();
      try { validate(value);if (value.legs.length && (!loaded || !complete())) throw Error('Vel setur og skriva nøvn til øll ferðafólk.');finish(value); }
      catch (e) { status.textContent = e.message; }
    }, 'tps-confirm');
    actions.append(button('Aftur', () => finish(null)), confirm);
    dialog.addEventListener('cancel', e => { e.preventDefault();finish(null); });
    dialog.addEventListener('close', () => { if (alive) finish(null); });
    const selection = () => ({...base, unitPrice, legs: LEGS.flatMap((leg, i) => enabled[i] ? [{flight: leg.flight, passengers: names.map((name, j) => ({name: name.trim(), seat: seats[i][j]}))}] : [])});
    const complete = () => names.every(x => x.trim() && x.trim().length <= 100) && enabled.every((on, i) => !on || (states[i] && seats[i].every(s => s && !states[i][s])));
    function totals() {
      const saving = enabled.filter(Boolean).length * n * unitPrice;
      const fee = full ? 0 : saving;
      summary.replaceChildren(node('div', 'Ferð: ' + money(total)), node('div', 'Val av setri: ' + money(fee)), node('div', 'Samlaður prísur: ' + money(total + fee)), node('strong', 'At gjalda nú við bankaflyting: ' + money(full ? total : n * 50000 + fee)), node('div', full ? 'Val av setri er ókeypis. Tú sparir ' + money(saving) + '.' : 'Depositum: ' + n + ' × ' + money(50000) + ' = ' + money(n * 50000) + ' + gjald fyri setur ' + money(fee)), node('div', 'Eftir at gjalda seinni: ' + money(full ? 0 : total - n * 50000)));
      confirm.textContent = enabled.some(Boolean) ? 'Halt fram við valdu setrunum' : 'Halt fram uttan at velja setur';
      confirm.disabled = enabled.some(Boolean) && (!loaded || refreshing || !complete());
    }
    function render() {
      details.hidden = !enabled.some(Boolean);
      if (!enabled[activeLeg]) activeLeg = enabled.findIndex(Boolean);
      tabs.replaceChildren();paxBox.replaceChildren();cabin.replaceChildren();
      LEGS.forEach((leg, i) => { if (!enabled[i]) return;const b = button(leg.label, () => {activeLeg = i;render();});b.setAttribute('aria-pressed', String(i === activeLeg));tabs.append(b); });
      if (activeLeg >= 0) {
        names.forEach((name, i) => { const b = button((name.trim() || 'Ferðandi ' + (i + 1)) + ' · ' + (seats[activeLeg][i] || 'Vel setur'), () => {passenger = i;render();});b.setAttribute('aria-pressed', String(i === passenger));paxBox.append(b); });
        for (let r = 1; r <= 29; r++) {
          const row = node('div', null, 'tps-row');
          for (const c of ['A', 'B', 'C', '', 'D', 'E', 'F']) {
            if (!c) {row.append(node('span', String(r)));continue;}
            const seat = r + c, taken = states[activeLeg]?.[seat], assigned = seats[activeLeg].indexOf(seat);
            const b = button(taken ? '×' : seat, () => {
              if (taken || !loaded || refreshing) return;
              if (assigned >= 0 && assigned !== passenger) { passenger = assigned;render();return; }
              const previous = seats[activeLeg][passenger];seats[activeLeg][passenger] = previous === seat ? '' : seat;
              if (activeLeg === 1) returnEdited[passenger] = true;
              suggestReturnSeats();
              if (previous !== seat) {const next = seats[activeLeg].findIndex(s => !s);if (next >= 0) passenger = next;}
              render();
            });
            b.disabled = !loaded || refreshing || Boolean(taken);b.setAttribute('aria-pressed', String(assigned >= 0));
            b.setAttribute('aria-label', seat + (taken ? ' · Upptikið' : assigned >= 0 ? ' · ' + (names[assigned] || 'Ferðandi ' + (assigned + 1)) : ' · Tøkt'));
            row.append(b);
          }
          cabin.append(row);
        }
      }
      totals();
    }
    LEGS.forEach((leg, i) => {
      const label = node('label', null, 'tps-option'), check = node('input'), text = node('span', leg.label);
      check.type = 'checkbox';check.checked = enabled[i];check.disabled = true;checks.push(check);label.append(check, text);choices.append(label);
      check.addEventListener('change', () => {
        enabled[i] = check.checked;activeLeg = i;
        if (i === 1) returnOptOut = !check.checked;
        if (i === 0 && check.checked && !returnOptOut) { enabled[1] = true;checks[1].checked = true; }
        if (!loaded && !check.checked) check.disabled = true;
        suggestReturnSeats();render();
      });
    });
    names.forEach((_, i) => {
      const label = node('label', 'Ferðandi ' + (i + 1), 'tps-name'), input = node('input');input.type = 'text';input.value = names[i];input.maxLength = 100;input.autocomplete = 'off';
      input.addEventListener('input', () => {names[i] = input.value;totals();});input.addEventListener('change', render);label.append(input);namesBox.append(label);
    });
    const reload = button('Dagfør listan við tøkum setrum', () => refresh());
    details.append(namesBox, tabs, node('p', 'Vel ferðandi omanfyri og síðani eitt tøkt setur.'), paxBox, reload, cabin, node('p', 'Ljóst: tøkt · Blátt: valt · ×: upptikið. Setur verða fyrst hildin av, tá bíleggingin verður løgd í kurvina.', 'tps-small'));
    dialog.append(heading, intro, choices, returnHint, status, details, summary, actions);document.body.append(dialog);
    async function refresh() {
      if (!alive || refreshing || document.hidden) return;refreshing = true;totals();
      try {
        const [v, ...data] = await Promise.all([product(config), ...LEGS.map(l => json(api(config) + '/availability?flight=' + encodeURIComponent(l.flight)))]);
        if (!alive) return;
        if (loaded && unitPrice !== v.price) {enabled.fill(false);checks.forEach(c => {c.checked = false;});status.textContent = 'Prísurin fyri setur er broyttur. Vel ferðina av nýggjum.';}
        else status.textContent = full ? 'Val av setri er ókeypis á báðum ferðum, tá ið tú rindar alla ferðina nú.' : 'Val av setri: ' + money(v.price) + ' fyri hvønn ferðandi hvønn vegin.';
        unitPrice = v.price;
        data.forEach((d, i) => {
          if (!d.seats || typeof d.seats !== 'object' || Array.isArray(d.seats)) throw Error('Tað bar ikki til at vísa setrini.');
          states[i] = Object.fromEntries(Object.entries(d.seats).filter(([, value]) => value.status !== 'free'));
          seats[i] = seats[i].map(s => states[i][s] ? '' : s);
        });
        loaded = true;checks.forEach(c => {c.disabled = false;});suggestReturnSeats();
      } catch (e) { if (alive) {loaded = false;checks.forEach(c => {c.disabled = !c.checked;});status.textContent = e.message + ' Tú kanst bíleggja ferðina uttan at velja setur.';} }
      finally {refreshing = false;if (alive) render();}
    }
    const timer = setInterval(refresh, 30000);
    render();dialog.showModal();refresh();return result;
  }
  async function prepare(config, selection, depositId, properties) {
    const fee = validate(selection), n = selection.n;
    const props = {'_tur_language': 'fo', '_tur_payment_flow': 'fo-deposit', 'Gjaldstreytir': "Flytið depositum á 500 DKK fyri hvønn ferðandi og gjaldið fyri val av setri beinanvegin við bankaflyting. Ferðin er frásett, tá ið vit hava móttikið gjaldið. Restin av ferðaprísinum skal vera goldin við bankaflyting í seinasta lagi 30. desember 2026.", ...properties, 'Samlaður ferðaprísur': money(selection.baseTotal + fee), 'Depositum': money(n * 50000),
      'Val av setri': money(fee), 'At gjalda nú': money(n * 50000 + fee), 'Eftir at gjalda': money(selection.baseTotal - n * 50000),
      '_tur_total_price_cents': String(selection.baseTotal + fee)};
    const plan = {items: [{id: depositId, quantity: n, properties: props}], expected: n * 50000 + fee, fee, packageId: null};
    if (!selection.legs.length) return plan;
    if (String(depositId) !== DEPOSIT) throw Error('Val av setri krevur depositumsproduktið á 500 DKK.');
    if (pending()) throw uncertain(Error('Ein fyrri bílegging skal kannast.'), pending());
    const [v, cart] = await Promise.all([product(config), json(root() + 'cart.js')]);
    if (v.price !== selection.unitPrice) throw Error('Prísurin fyri setur er broyttur. Vel setur av nýggjum.');
    if (cart.item_count) throw Error('Kurvin skal vera tóm, áðrenn tú bíleggur henda pakkan.');
    const id = crypto.randomUUID();setPending(id);plan.packageId = id;
    let reservation;
    try {
      reservation = await json(api(config) + '/reserve-package', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({package: id, deposit_variant: DEPOSIT, party_size: n, legs: selection.legs})});
    } catch (e) {
      // A definite validation/conflict response rolled back the whole transaction.
      if ([400, 401, 403, 404, 409, 413, 503].includes(e.httpStatus)) {sessionStorage.removeItem(LOCK);throw e;}
      throw uncertain(e, id);
    }
    try {
      if (reservation.package !== id || !reservation.package_token || !Array.isArray(reservation.legs) || reservation.legs.length !== selection.legs.length) throw Error('Reservationin skal kannast.');
      props._tur_package = id;props._tur_package_token = reservation.package_token;
      for (const leg of selection.legs) {
        const matches = reservation.legs.filter(x => x.flight === leg.flight);
        if (matches.length !== 1 || !matches[0].booking || !matches[0].token) throw Error('Reservationin skal kannast.');
        const r = matches[0];
        for (const p of leg.passengers) plan.items.push({id: SEAT, quantity: 1, properties: {
          '_tur_booking': r.booking, '_tur_package': id, '_tur_seat_token': r.token,
          'Ferð': properties['Ferð'] || 'Akureyri', 'Dagsetning': leg.flight.slice(0, 10), 'Flugleið': leg.flight.slice(11),
          'Farþegi': p.name.trim(), 'Setur': p.seat, 'Tegund': 'Val av setri við pakka'
        }});
      }
      return plan;
    } catch (e) {throw uncertain(e, id);}
  }
  function verifyCart(cart, plan) {
    if (cart.currency !== 'DKK' || cart.total_price !== plan.expected || cart.items.length !== plan.items.length) throw Error('Upphæddin í kurvini skal kannast.');
    const unused = [...cart.items];
    for (const expected of plan.items) {
      const i = unused.findIndex(line => String(line.variant_id || line.id) === String(expected.id) && line.quantity === expected.quantity &&
        Object.entries(expected.properties).every(([k, v]) => String(line.properties?.[k] ?? '') === String(v)));
      if (i < 0) throw Error('Ferðafólk, setur ella depositum í kurvini skulu kannast.');
      const [line] = unused.splice(i, 1);
      const price = expected === plan.items[0] ? expected.quantity * 50000 : plan.fee / (plan.items.length - 1);
      if (line.final_line_price !== price) throw Error('Depositum ella prísurin fyri setur í kurvini skal kannast.');
    }
    return true;
  }
  // Keep the lock after posting or uncertain results. It is cleared only after
  // this exact cart is verified, at which point the cart's own empty-cart guard applies.
  function complete(plan, cart) {verifyCart(cart, plan);if (plan.packageId && pending() === plan.packageId) sessionStorage.removeItem(LOCK);}
  window.TurPackageSeats = Object.freeze({choose, prepare, verifyCart, complete, validate, uncertain});
})();


